class CartUpsell extends HTMLElement {
  connectedCallback() {
    if (this.bound) return;
    this.bound = true;
    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-upsell-add]');
      if (button) this.add(button);
    });
  }

  add(button) {
    if (button.getAttribute('aria-disabled') === 'true') return;
    const cart = document.querySelector('cart-drawer');
    const errorWrapper = this.querySelector('[data-upsell-error]');
    const showError = (message) => {
      if (!errorWrapper) return;
      errorWrapper.textContent = message || '';
      errorWrapper.classList.toggle('hidden', !message);
    };
    showError();
    button.setAttribute('aria-disabled', true);

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    const formData = new FormData();
    formData.append('id', button.dataset.variantId);
    formData.append('quantity', 1);
    if (cart) {
      formData.append('sections', cart.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
    }
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          showError(response.description || response.message);
          button.removeAttribute('aria-disabled');
          return;
        }
        if (!cart || document.querySelector('cart-items[data-cart-items]')) {
          // Cart page (or no drawer): reload so the item list and totals refresh.
          window.location.reload();
          return;
        }
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-upsell',
          productVariantId: button.dataset.variantId,
          cartData: response,
        });
        cart.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
        button.removeAttribute('aria-disabled');
      });
  }
}
if (!customElements.get('cart-upsell')) customElements.define('cart-upsell', CartUpsell);

class CartDiscount extends HTMLElement {
  connectedCallback() {
    if (this.bound) return;
    this.bound = true;
    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-discount-apply]')) this.apply();
      if (event.target.closest('[data-discount-remove]')) this.update('');
    });
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && event.target.matches('[data-discount-input]')) {
        event.preventDefault();
        this.apply();
      }
    });
  }

  showMessage(text, isError) {
    const message = this.querySelector('[data-discount-message]');
    if (!message) return;
    message.textContent = text;
    message.classList.toggle('cart-discount__message--error', !!isError);
    message.hidden = false;
  }

  apply() {
    const input = this.querySelector('[data-discount-input]');
    const code = (input ? input.value : this.dataset.discountCode || '').trim();
    if (code) this.update(code);
  }

  // Sets the cart's discount code (an empty code removes it) so the total updates before checkout.
  update(code) {
    const button = this.querySelector('[data-discount-apply], [data-discount-remove]');
    const cart = document.querySelector('cart-drawer');
    const label = button ? button.textContent : '';
    if (button) {
      button.setAttribute('aria-disabled', true);
      button.textContent = code ? 'Taikoma…' : 'Šalinama…';
    }

    const body = { discount: code };
    if (cart) {
      body.sections = cart.getSectionsToRender().map((section) => section.section);
      body.sections_url = window.location.pathname;
    }
    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body: JSON.stringify(body) })
      .then((response) => response.json())
      .then((response) => {
        if (code) {
          const entry = (response.discount_codes || []).find(
            (discount) => discount.code.toLowerCase() === code.toLowerCase()
          );
          if (response.status || !entry || !entry.applicable) {
            this.showMessage(`Kodas „${code}“ negalioja arba netinka šiam krepšeliui.`, true);
            return;
          }
        }
        if (!cart || !response.sections) {
          window.location.reload();
          return;
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-discount', cartData: response });
        cart.renderContents(response);
      })
      .catch(() => {
        this.showMessage('Nepavyko pritaikyti kodo. Pabandykite dar kartą arba įveskite jį atsiskaitymo metu.', true);
      })
      .finally(() => {
        if (!button) return;
        button.removeAttribute('aria-disabled');
        button.textContent = label;
      });
  }
}
if (!customElements.get('cart-discount')) customElements.define('cart-discount', CartDiscount);
